<wbo-select-option [value]="ReasonCodeData.DISCOUNT_TYPE" label="wbo.reason-code.option.codeType.discount">
</wbo-select-option>
<wbo-select-option [value]="ReasonCodeData.PRICE_REDUCTION_TYPE" label="wbo.reason-code.option.codeType.price-reduction">
</wbo-select-option>
<wbo-select-option [value]="ReasonCodeData.REFUND_TYPE" label="wbo.reason-code.option.codeType.refund">
</wbo-select-option>
<wbo-select-option [value]="ReasonCodeData.REOPEN_TYPE" label="wbo.reason-code.option.codeType.reopen">
</wbo-select-option>
<wbo-select-option [value]="ReasonCodeData.RETURN_TYPE" label="wbo.reason-code.option.codeType.return">
</wbo-select-option>
<wbo-select-option [value]="ReasonCodeData.VOID_TYPE" label="wbo.reason-code.option.codeType.void">
</wbo-select-option>
<wbo-select-option [value]="ReasonCodeData.WASTAGE_TYPE" label="wbo.reason-code.option.codeType.wastage">
</wbo-select-option>
